<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="filtroNome"
          label="Buscar por nome"
          prepend-icon="mdi-magnify"
          class="mb-4"
          clearable
        />
        <v-spacer />
        <!-- <v-btn color="primary" @click="adicionarPessoa">Adicionar Novo</v-btn> -->
      </v-card-title>

      <v-card-text>
        <div v-for="(pessoa, index) in pessoasFiltradas" :key="index" class="mb-8">
          <v-card class="pa-4">
            <v-tabs v-model="abas[index]" background-color="primary" dark grow>
              <v-tab>Identificação</v-tab>
            </v-tabs>

            <v-tabs-items v-model="abas[index]">
              <v-tab-item>
                <v-row class="mt-5">
                  <v-col cols="12"
                    ><v-text-field v-model="pessoa.nome" label="Nome Completo" dense outlined
                  /></v-col>

                  <v-col cols="4"
                    ><v-text-field
                      v-model="pessoa.inep_escola"
                      label="Cód. Escola INEP"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-text-field
                      v-model="pessoa.cod_pessoa_fisica_sistema"
                      label="Cód. Sistema"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-text-field v-model="pessoa.inep" label="ID INEP" dense outlined
                  /></v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-select
                      :items="['1 - Diretor(a)', '2 - Outro Cargo']"
                      v-model="pessoa.cargo"
                      label="Cargo"
                      solo
                      class="px-2"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="[
                        '1 - Ser proprietário(a) ou sócio(a)-proprietário(a) da escola',
                        '2 - Exclusivamente por indicação/escolha da gestão',
                        '3 - Processo seletivo qualificado e escolha/nomeação da gestão',
                        '4 - Concurso público específico para o cargo de gestor escolar',
                        '5 - Exclusivamente por processo eleitoral com a participação da comunidade escolar',
                        '6 - Processo seletivo qualificado e eleição com a participação da comunidade escolar',
                        '7 - Outros',
                      ]"
                      v-model="pessoa.acesso_ao_cargo"
                      label="Critério de acesso ao Cargo/Função"
                      solo
                      class="px-2"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="[
                        '1 - Concursado/efetivo/estável',
                        '2 - Contrato temporário',
                        '3 - Contrato terceirizado',
                        '4 - Contrato CLT',
                      ]"
                      v-model="pessoa.situacao_funcional"
                      label="Situação Funcional/Regime de contratação/Tipo de vínculo"
                      solo
                      class="px-2"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>
        <v-row class="mt-4">
          <v-col cols="6">
            <v-btn block color="error" @click="submitForm('prev')">
              <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn block color="success" @click="submitForm('next')">
              <v-icon>mdi-chevron-right</v-icon> Próxima Etapa</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    pessoasFiltradas() {
      if (!this.filtroNome) return this.pessoas;
      return this.pessoas.filter((p) =>
        p.nomecompleto?.toLowerCase().includes(this.filtroNome.toLowerCase())
      );
    },
  },
  data() {
    return {
      filtroNome: "",
      emailRule: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
      pessoas: [{}],
      abas: [0],
      binarios: ["0", "1"],
      sexos: ["1 - Masculino", "2 - Feminino", "3 - Outro"],
      cores: [
        "0 - Não Declarada",
        "1 - Branca",
        "2 - Preta",
        "3 - Parda",
        "4 - Amarela",
        "5 - Indígena",
      ],
      nacionalidades: [
        "1 - Brasileira",
        "2 - Brasileira - nascido no Exterior ou Naturalizado",
        "3 - Estrangeira",
      ],
      menu: false,
      deficiencias: [
        "cegueira",
        "baixa_visao",
        "visao_monocular",
        "surdez",
        "deficiencia_auditiva",
        "surdocegueira",
        "deficiencia_fisica",
        "deficiencia_intelectual",
        "deficiencia_multipla",
        "transtorno_espectro_autista",
        "altas_habilidades_superdotacao",
        "transtornos_aprendizagem",
        "discalculia",
        "disgrafia_disortografia",
        "dislalia",
        "dislexia",
        "tdah",
        "tpac",
      ],
      recursos: [
        "auxilio_ledor",
        "auxilio_transcricao",
        "guia_interprete",
        "tradutor_interprete_libras",
        "leitura_labial",
        "prova_ampliada",
        "prova_super_ampliada",
        "cd_audio",
        "prova_lingua_portuguesa",
        "prova_video_libras",
        "material_didatico_braille",
        "prova_em_braille",
        "tempo_adicional",
        "nenhum_recurso",
        "",
      ],
      municipiosNasc: [],
      municipiosRes: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.$loaderService.open("Carregando...");
      const data = await this.$services.censoService.getData("aba40");
      this.formData = data;
      if (data) {
        this.pessoas = data;
      }
      this.$loaderService.close();
    },
    async pesquisarCep(cep) {
      // if (cep.length === 9) {
      //   const cepData = await this.$services.cepService.buscarDadosDoCep(cep);
      //   this.formData.cep = cepData.cep;
      //   this.formData.logradouro = cepData.rua;
      //   this.formData.bairro = cepData.bairro;
      //   this.formData.codigo_municipio = cepData.cidade;
      // }
    },
    atualizarEstado(value) {
      if (value) {
        this.municipiosNasc = this.$constants.municipios[value].cidades;
      }
    },

    atualizarEstadoRes(value) {
      if (value) {
        this.municipiosRes = this.$constants.municipios[value].cidades;
      }
    },
    adicionarPessoa() {
      this.pessoas.push({});
      this.abas.push(0);
    },
    removerPessoa(index) {
      this.pessoas.splice(index, 1);
      this.abas.splice(index, 1);
    },

    async submitForm(type) {
      try {
        await this.$services.censoService.saveData(this.pessoas, "aba40");
        if (type === "next") {
          this.$emit("event", "tab-6");
        } else {
          this.$emit("event", "tab-4");
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    formatarCampo(campo) {
      return campo.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },
};
</script>

<style scoped>
.v-card {
  border: 1px solid #ccc;
}
</style>
